import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { ClientProposalOwnerActionEnum } from '../../../../../../lib/graphql'

const getTipContent = ({
  clientProposalOwnerCurrentAction,
}: {
  clientProposalOwnerCurrentAction: ClientProposalOwnerActionEnum
}) => {
  if (clientProposalOwnerCurrentAction) {
    switch (clientProposalOwnerCurrentAction) {
      case ClientProposalOwnerActionEnum.BOOKING_DECLINED_BY_HOST:
        return (
          <FormattedMessage
            id='ui.getTipContent.bookingDeclinedByHost'
            defaultMessage='✉️ Si vous avez refusé cette demande par erreur, contactez votre conseiller Naboo au plus vite'
          />
        )
      case ClientProposalOwnerActionEnum.BOOKING_DECLINED_BY_USER_ADMIN:
        return (
          <FormattedMessage
            id='ui.getTipContent.bookingDeclinedByUserAdmin'
            defaultMessage="Un devis non compatible signifie qu'il ne correspond pas à la politique budgétaire de l'entreprise
            du contact"
          />
        )
      case ClientProposalOwnerActionEnum.CAN_UPLOAD_QUOTATION:
      case ClientProposalOwnerActionEnum.CAN_CONFIRM_QUOTATION:
        return (
          <FormattedMessage
            id='ui.getTipContent.canConfirmQuotation'
            defaultMessage='👀 Dès lors que vous aurez validé votre devis nous pourrons le présenter au client.'
          />
        )
      case ClientProposalOwnerActionEnum.WAITING_USER_BOOKING_CONFIRMATION:
      case ClientProposalOwnerActionEnum.CAN_RE_UPLOAD_QUOTATION:
        return (
          <FormattedMessage
            id='ui.getTipContent.waitingUserBookingConfirmation'
            defaultMessage='👀 Le client est en train d’examiner votre devis, vous serez informé immédiatement de son choix !'
          />
        )
      case ClientProposalOwnerActionEnum.CAN_CONFIRM_BOOKING:
        return (
          <FormattedMessage
            id='ui.getTipContent.canConfirmBooking'
            defaultMessage='💳 Une fois la réservation acceptée, le client pourra procéder au règlement de l’acompte.'
          />
        )
      case ClientProposalOwnerActionEnum.WAITING_USER_PAY_DEPOSIT:
        return (
          <FormattedMessage
            id='ui.getTipContent.waitingUserPayDeposit'
            defaultMessage='🎉 La réservation est confirmée, le client a été invité à payer un acompte qui vous sera versé à réception'
          />
        )
      case ClientProposalOwnerActionEnum.DEPOSIT_PAID:
        return (
          <FormattedMessage
            id='ui.getTipContent.depositPaid'
            defaultMessage='🎉 Félicitations, le client a réglé son acompte, nous vous le transférons dans les meilleurs délais'
          />
        )
      case ClientProposalOwnerActionEnum.CAN_CONFIRM_ADJUSTMENTS:
        return (
          <FormattedMessage
            id='ui.getTipContent.canConfirmAdjustments'
            defaultMessage='✍️ Le client souhaite ajuster le devis initial. Si vous acceptez ces ajustements, le client sera facturé du
            solde avant séjour'
          />
        )
      case ClientProposalOwnerActionEnum.ADJUSTMENTS_CONFIRMED:
        return (
          <FormattedMessage
            id='ui.getTipContent.adjustmentsConfirmed'
            defaultMessage='✅ Vous avez accepté les ajustements demandés par le client. Celui ci est maintenant invité à régler son
            solde avant séjour !'
          />
        )
      case ClientProposalOwnerActionEnum.CAN_CONTACT_ADMIN:
        return (
          <FormattedMessage
            id='ui.getTipContent.canContactAdmin'
            defaultMessage='👋 Nous vous invitons à prendre contact avec votre client. Votre conseiller Naboo reste à votre disposition
            en cas de besoin !'
          />
        )
      case ClientProposalOwnerActionEnum.CAN_SEND_FEEDBACK:
        return (
          <FormattedMessage
            id='ui.getTipContent.canSendFeedback'
            defaultMessage='🖐️ Votre avis compte, aidez nous à nous améliorer en nous partageant vos retours sur ce séjour'
          />
        )
    }
  }
}

const TipContent = ({
  clientProposalOwnerCurrentAction,
}: {
  clientProposalOwnerCurrentAction: ClientProposalOwnerActionEnum
}) => {
  return (
    <span className={s.tip}>
      {getTipContent({
        clientProposalOwnerCurrentAction,
      })}
    </span>
  )
}

export default TipContent
